import { createTheme } from "@mui/material";
import { grey } from "@mui/material/colors";

const darkMode = createTheme({

    palette:{
      mode: 'dark',
      primary: {
        main: '#1A1B41',
      },
      secondary: {
        main: '#baff29',
        
      },
      error:{
        main: "#ff4444"
      },
      text:{
        primary: grey[200]
      },
      divider: 'rgba(255, 255, 255, 0.1)'
    },
    typography:{
      fontFamily: '"Poppins", "sans-serif"',
    },
    shape:{
      borderRadius: 4
    }
  
  })

export default darkMode